import SliderButtons from './SliderButtons.component';

export default SliderButtons;
